import { useState, useEffect } from "react";
import AppColors from 'general/constants/AppColors';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import KTBSDropdown, {
  KTBSDropdowAutoCloseBehavior,
  KTBSDropdownAlignments,
  KTBSDropdownDirections,
} from '../OtherKeenComponents/KTBSDropdown';

DropdownFilterTable.propTypes = {
  filterComponent: PropTypes.arrayOf(PropTypes.node),
  resetDefaultTable: PropTypes.func,
  saveFilter: PropTypes.func,
  direction: PropTypes.oneOf(Object.values(KTBSDropdownDirections)),
  isDefaultFilter: PropTypes.bool,
  isLightButton: PropTypes.bool,
  toggleElementBorderRadius: PropTypes.number,
  id: PropTypes.string,
};

function DropdownFilterTable({
  filterComponent = [],
  resetDefaultTable,
  saveFilter,
  direction = KTBSDropdownDirections.down,
  isDefaultFilter = true,
  isLightButton = false,
  toggleElementBorderRadius = 5,
  id = 'dropdown-filter-table',
}) {

  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const listener = (event) => {
      const dropdownElement = document.getElementById(`${id}`);
      if (dropdownElement && dropdownElement.contains(event.target)) {
        return;
      }
      const flatpickrCalendars = document.querySelectorAll(".ant-picker-dropdown");
      for (let calendar of flatpickrCalendars) {
        if (calendar.contains(event.target)) {
          return;
        }
      }
      if (show) {
        setShow(false);
        saveFilter();
      }
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [show, saveFilter]);

  return (
    <div id={`${id}`} className="position-relative">
      <div
        onClick={() => setShow(!show)}
        className={`btn ${isLightButton ? 'btn-white' : 'btn-light'} font-weight-bold d-flex align-items-center`}
        style={{
          border: isLightButton ? `1px solid ${AppColors.gray[300]}` : '',
          borderRadius: toggleElementBorderRadius,
          minWidth: 90
        }}
      >
        <div className={`position-relative ${!isDefaultFilter ? "mr-1" : ""}`}>
          <i
            className={isLightButton ? 'fa-regular fa-filter' : 'fa-solid fa-filter'}
            style={{ color: AppColors.gray[800], fontSize: 15 }}
          ></i>
          {!isDefaultFilter && (
            <span
              className="rounded-circle"
              style={{
                position: "absolute",
                right: 0,
                top: -3,
                width: "7px",
                height: "7px",
                backgroundColor: "orange",
              }}
            />
          )}
        </div>
        <span
          className="font-weight-bolder"
          style={{ color: AppColors.gray[800], fontSize: 14 }}
        >
          Bộ lọc
        </span>
      </div>

      {show && (
        <div
          className={`position-absolute shadow min-w-400px bg-white rounded-lg pt-2`}
          style={{
            top: direction === "dropdown" ? "100%" : "auto",
            bottom: direction === "dropup" ? "100%" : "auto",
            right: 0,
            zIndex: 1000,
          }}
        >
          <div className="d-flex flex-column p-4">
            {filterComponent?.map((component, index) => (
              <div key={index}>{component}</div>
            ))}
          </div>
          <div className="d-flex w-100 align-items-center justify-content-end gap-2 p-4 border-top">
            <button
              className="btn btn-secondary font-weight-bolder mr-2"
              style={{
                fontSize: 14,
                color: AppColors.gray[800],
              }}
              onClick={() => {
                resetDefaultTable();
                setShow(false);
              }}
            >
              Đặt lại mặc định
            </button>
            <button
              className="btn btn-success font-weight-bolder text-white"
              style={{
                fontSize: 14,
              }}
              onClick={() => {
                saveFilter();
                setShow(false);
              }}
            >
              Lọc ngay
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default DropdownFilterTable;